import React from "react";
import ReactPlayer from "react-player";

interface VideoComponentProps {
  url: string;
}

const VideoComponent: React.FC<VideoComponentProps> = ({ url }) => {
  return (
      <ReactPlayer
        url={url}
        width="100%"
        height="350px"
        controls={false}
        className="rounded-circle"
        config={{ youtube: { playerVars: { showinfo: 0, controls: 0 } } }}
      />
  );
};

export default VideoComponent;
